import React from 'react';

import { ImpressionProvider } from '@thd-olt-component-react/impression';
import { string } from 'prop-types';
import { ProductRowPlaceholder } from '../ProductPodPlaceholders/ProductRowPlaceholder';
import { useSpecialBuy } from '../../context/SpecialBuyProvider';
import { CategoryProducts } from '../CategoryProducts/CategoryProducts';

const SpecialBuyCarousel = ({ entryId }) => {
  const { categories, selectedCategory } = useSpecialBuy();

  const impressionData = {
    id: entryId || '',
    name: 'SpecialBuyBanner',
    component: 'SpecialBuyBanner',
    type: 'product',
    position: '',
    category: selectedCategory?.categoryId || ''
  };

  return (
    <ImpressionProvider data={impressionData}>
      <section>
        {!categories.length ? (
          <ProductRowPlaceholder />
        ) : (
          <>
            {categories.map((category) => (
              <CategoryProducts
                key={category.categoryId}
                category={category}
              />
            ))}
          </>
        )}
      </section>
    </ImpressionProvider>
  );
};

SpecialBuyCarousel.displayName = 'SpecialBuyCarousel';

SpecialBuyCarousel.propTypes = {
  entryId: string
};

SpecialBuyCarousel.defaultProps = {
  entryId: null
};

export { SpecialBuyCarousel };
